export default __webpack_public_path__ + "static/media/closet1-768w.f78a0005.webp";